/* eslint-disable */
import {toJS} from "mobx";
import {Form} from "react-final-form";
import ModalFormField from "containers/Admin/components/ModalFormField";
import Modal from "components/Modal";
import Button from "components/Button";
import {useTranslation} from "react-i18next";
import React from "react";

const AddCommonTrendParameterConstraintsModal = ({visible, onSubmit, onCancel, fields}) => {
    const {t} = useTranslation();

    return (
        <>
            <Form
                onSubmit={onSubmit}
                render={({handleSubmit, form, submitting, pristine, errors, submitError}) => (
                    <Modal
                        width={"40vw"}
                        bodyStyle={{
                            display: "flex",
                            flexDirection: "column"
                        }}
                        visible={visible}
                        titleText={t("addCommonTrendParameterConstraints")}
                        className="add-priority-modal"
                        onCancel={() => {
                            onCancel();
                        }}
                        submitButton={(
                            <Button
                                text={t("apply")}
                                disabled={submitting || pristine}
                                onClick={async (event) => {
                                    if (Object.keys(errors).length !== 0) {
                                        handleSubmit(event);
                                        return;
                                    }

                                    if (!await handleSubmit(event))
                                        form.restart();
                                }}
                            />
                        )}
                    >
                        <div style={{padding: "0px 20px"}}>
                            <div className={"ant-form-item"} style={{display: "flex"}}>
                                <ModalFormField key={fields.parameter.name} field={toJS(fields.parameter)}/>
                            </div>

                            <span>Коэффициенты угла наклона аппроксимируемой прямой: </span>
                            <div className={"ant-form-item"} style={{display: "flex"}}>
                                <ModalFormField key={fields.approxConstraints[0].name}
                                                field={toJS(fields.approxConstraints[0])}/>
                                <ModalFormField key={fields.approxConstraints[1].name}
                                                field={toJS(fields.approxConstraints[1])}/>
                            </div>

                            <span>Настройки определения изменения показателя: </span>
                            <div className={"ant-form-item"} style={{display: "flex"}}>
                                <ModalFormField key={fields.deltaValueConstraint.name}
                                                field={toJS(fields.deltaValueConstraint)}/>
                            </div>

                            <span>Настройки для определения поведения «пилы»: </span>
                            <div className={"ant-form-item"} style={{display: "flex", flexDirection: "column"}}>
                                <ModalFormField key={fields.sawConstraints[0].name}
                                                field={toJS(fields.sawConstraints[0])}/>
                                <ModalFormField key={fields.sawConstraints[1].name}
                                                field={toJS(fields.sawConstraints[1])}/>
                                <ModalFormField key={fields.sawConstraints[2].name}
                                                field={toJS(fields.sawConstraints[2])}/>
                            </div>
                            <div className={"ant-form-item"} style={{display: "flex", flexDirection: "column"}}>
                        <span>
                            <span style={{fontWeight: "bold"}}>Временной интервал (в минутах)</span>
                            {" — задаёт период анализа данных для выявления колебаний"}
                        </span>
                                <span>
                            <span style={{fontWeight: "bold"}}>Количество изменений за интервал</span>
                                    {" — определяет минимальное число перепадов значений параметра, при котором фиксируется «пила»"}
                        </span>
                                <span>
                            <span style={{fontWeight: "bold"}}>Разница значений параметра за интервал</span>
                                    {" — устанавливает минимально допустимый разброс величин для признания колебаний значимыми признаками «пилы»"}
                        </span>
                            </div>
                        </div>
                        <div style={{padding: "10px", textAlign: "center", color: "red"}}>
                            {submitError}
                        </div>
                    </Modal>
                )}
            />
        </>
    )
}

export {AddCommonTrendParameterConstraintsModal}